<template>
    <div>
        <el-dialog :visible.sync="showFlag" :title="'列配置'" @close="tableConfigClose">
            <configuration :checkedList="checkedList" :selectAllColumns="allColumns" ref="dialog"
                @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
        </el-dialog>
    </div>
</template>

<script>
import { getList } from '../../../../lsrm/api/annoMana.js';
import configuration from '@/components/otpPanel/configuration-list';
import { mapGetters } from 'vuex';
export default {
    props: {
        showModal: {
            type: Boolean,
            default () {
                return false;
            }
        },
        allColumns: {
            type: Array,
            default () {
                return [];
            }
        },
        columnsList: {
            type: Array,
            default () {
                return [];
            }
        },
        subjectType: {
            type: String,
            default() {
                return 'tenderList250415';
            }
        }
    },
    watch: {
        showModal(val) {
            if (val) {
                this.showFlag = val;
            }
        }
    },
    components: { configuration },
    data() {
        return {
            columnNum: 500,
            showFlag: false,
            resourceCode: '',
            checkedList: '',
            colList: []
        };
    },
    computed: {
        ...mapGetters(['menus', 'currentTenant', 'applicationCode'])
    },
    methods: {
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.deepFunc(childrens);
                }
            }
        },
        deepFunc(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path || (childrens[i].frontUrl === '/index' && this.$route.path === '/')) {
                    this.resourceCode = childrens[i].resourceCode;
                    this.frontUrl = childrens[i].frontUrl;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        getList(pramas) {
            return getList.get(pramas).then(res => {
                const datas = res && res.data.configNameCn ? res.data.configNameCn.split(',') : [];
                this.colList = [];
                if (!datas.length) {
                    this.allColumns.map(data => {
                        this.colList.push(data);
                    });
                    const tabelConfigListArr = [];
                    const tabelConfigNameArr = [];
                    this.columnsList.forEach(el => {
                        tabelConfigListArr.push(el.label);
                        tabelConfigNameArr.push(el.prop);
                    });
                    const tabelConfigList = tabelConfigListArr.join(',');
                    const tabelConfigName = tabelConfigNameArr.join(',');
                    this.getTableConfigList(tabelConfigList, tabelConfigName);
                } else {
                    datas.map(title => {
                        this.allColumns.map(data => {
                            if (data.label === title) {
                                this.colList.push(data);
                            }
                        });
                    });
                }
                const arr = [];
                this.colList.forEach(el => {
                    arr.push(el.label);
                });
                this.checkedList = arr.join(',');
            });
        },
        async setConfigColumn(type) {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            await this.deepMenu(menu);
            const pramas = {
                'moduleCode': this.resourceCode,
                'subjectType': this.subjectType
            };
            await this.getList(pramas);
            return this.colList;
        },
        async getTableConfigList(tabelConfigList, tabelConfigName) {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            await this.deepMenu(menu);
            const pramas = {
                'configName': tabelConfigName,
                'configNameCn': tabelConfigList,
                'subjectType':  this.subjectType,
                'moduleCode': this.resourceCode
            };
            getList.post(pramas).then(() => {});

            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.allColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.showFlag = false;
            this.$emit('getColList', columnsList);
        },
        tableConfigClose() {
            this.showFlag = false;
            this.$emit('colClose', false);
        }
    }
};
</script>

<style>

</style>